import { createContext, useContext, useState, lazy, Suspense } from "react";

const QuizFlow = lazy(() =>
  import("@/components/quiz/QuizFlow").then((m) => ({ default: m.QuizFlow }))
);

const QuizContext = createContext(null);

export const QuizProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <QuizContext.Provider value={{ isOpen, open, close }}>
      {children}
      {isOpen && (
        <Suspense fallback={null}>
          <QuizFlow open={isOpen} onClose={close} />
        </Suspense>
      )}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => useContext(QuizContext);
